import { apiRequest } from "src/services/apiClient";

export interface DuplicateRecipient {
    id: string;
    salutation: string;
    title: string;
    firstName: string;
    lastName: string;
    sameAsPatientId: string;
}

export interface DuplicatePatient {
    id: string;
    firstName: string;
    lastName: string;
    birthDate?: string;
    recipient: DuplicateRecipient | null;
}

export interface PersonDuplicates {
    patients: DuplicatePatient[];
    recipients: DuplicateRecipient[];
}

/** The same person already in the praxis (GET /patients/duplicates) — name + birth date. */
export function findPersonDuplicates(firstName: string, lastName: string, birthDate: string): Promise<PersonDuplicates> {
    const qs = new URLSearchParams({ firstName: firstName.trim(), lastName: lastName.trim(), birthDate: birthDate.slice(0, 10) });
    return apiRequest<PersonDuplicates>(`/patients/duplicates?${qs}`);
}
